import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { LocationDetailFormValue } from 'src/app/pages/location-details/models/location-detail-form';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-location-info',
    styleUrls: ['./location-info.component.scss'],
    templateUrl: './location-info.component.html',
    standalone: false
})
export class LocationInfoComponent {
   @Input() location: LocationDetailFormValue;
}
